// src/config.js
export const STRATEGY = {
  NATIVE: "native",
  API: "api",
};

// Automatically reads from your .env file
export const CURRENT_STRATEGY =
  import.meta.env.VITE_strategy || STRATEGY.NATIVE;
export const API_BASE_URL =
  import.meta.env.VITE_apiBaseURL ||
  "https://us-central1-pos-service-fd1da.cloudfunctions.net/";
